import React from "react";

const QuotaExceedBanner = ({ infoName }) => {
  return (
    <div className="quota-exceed mb-3">
      {infoName} quota exceeded! Please check with your system administrator.
    </div>
  );
};

export default QuotaExceedBanner;
